import { put, takeLatest, call } from 'redux-saga/effects';
import { createAccountRequest, createAccountSuccess, createAccountFailure } from '../../actions/adminFlow/createAccountAction';
import { submitCreateAccount } from '../../../api/Admin/adminflowAPI';

function* createAccount(action) {
	try {
		const response = yield call(submitCreateAccount, action);
		if (response) {
			yield put(createAccountSuccess(response));
		}else {
			yield put(createAccountFailure(e));
		}
	} catch (e) {
		yield put(createAccountFailure(e));
	}

}

function* createAccountSaga() {
	yield takeLatest(createAccountRequest, createAccount);
}

export default createAccountSaga;
